import { Divider } from '@mui/material'
import { Subscriber } from '@weblite/ts-action/subscription'
import {
  UserListItemSkeleton,
  UserListItemWithStatus,
} from '$common/user-list-item'
import { EmptyStateList } from '$common/empty-state-list'
import { withSearchableInfiniteListPage } from '$common/searchable-list-page'
import {
  useHallNonAdminSubscribers,
  useSearchedHallNonAdminSubscribers,
} from '$logic/subscription/react-hook'
import {
  closeAddGroupExceptionMember,
  openDefineGroupMemberPermissionsOverride,
} from '$logic/router'
import { t } from '$i18n'

const ListItem = ({ id, admin, roomId }: Subscriber & { roomId: string }) => (
  <>
    <UserListItemWithStatus
      userId={id}
      role={admin ? t('common.admin') : null}
      hasDivider={false}
      onClick={() => openDefineGroupMemberPermissionsOverride(roomId, id)}
    />
    <Divider variant="inset" />
  </>
)

const Page = withSearchableInfiniteListPage<
  Subscriber,
  string,
  {
    roomId: string
    query: string
    fetchedItems: Subscriber[]
    hasMoreItemToLoad: boolean
  }
>({
  appBarTitle: t('settings.privacy.exception.add'),
  SkeletonItem: UserListItemSkeleton,
  EmptyStateComponent: () => <EmptyStateList />,
  fetchHook: useHallNonAdminSubscribers,
  searchHook: useSearchedHallNonAdminSubscribers,
  onBack: closeAddGroupExceptionMember,
})

export function AddGroupExceptionUser({ roomId }: { roomId: string }) {
  return (
    <Page
      fetchHookParams={roomId}
      getSearchHookParams={(query, items, hasMoreItemToLoad) => ({
        query,
        fetchedItems: items,
        hasMoreItemToLoad,
        roomId,
      })}
      ListItem={item => <ListItem {...item} roomId={roomId} />}
    />
  )
}
